import i18n from '@/i18n/i18n'
import { PhoneSurveyService } from '@/services/admin/PhoneSurveyService'
import { errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const state = {
  surveys: [],
  survey: {},
  questionTypes: [],
  question: {}
}

export const mutations = {
  SET_SURVEYS(state, surveys) {
    state.surveys = surveys
  },
  SET_SURVEY(state, survey) {
    state.survey = survey
  },
  SET_QUESTION_TYPES(state, questionTypes) {
    state.questionTypes = questionTypes
  },
  ADD_QUESTION(state, question) {
    state.survey.questions.push(question)
  },
  SET_QUESTION(state, question) {
    state.question = question
  }
}

export const actions = {
  getSurveys({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.getPhoneSurveys()
        .then(response => {
          commit('SET_SURVEYS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.get_surveys_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getSurvey({ commit, dispatch }, phoneSurveyId) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.getPhoneSurvey(phoneSurveyId)
        .then(response => {
          commit('SET_SURVEY', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.get_survey_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  sortQuestions({ dispatch, state }, questions) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.sortQuestions(questions)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.phone_survey.sort_questions_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.sort_questions_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  toggleStatus({ dispatch, state }, phoneSurveyId) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.toggleStatus(phoneSurveyId)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.phone_survey.toggle_status_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.toggle_status_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getQuestionTypes({ dispatch, commit }) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.getQuestionTypes()
        .then(response => {
          commit('SET_QUESTION_TYPES', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.get_question_types_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createQuestion({ commit, dispatch }, question) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.createQuestion(question)
        .then(response => {
          commit('ADD_QUESTION', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.create_question_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getQuestion({ dispatch, commit }, questionId) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.getQuestion(questionId)
        .then(response => {
          commit('SET_QUESTION', response.data)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.get_question_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateQuestion({ commit, dispatch, state }, question) {
    return new Promise((resolve, reject) => {
      PhoneSurveyService.updateQuestion(question)
        .then(response => {
          commit('SET_QUESTION', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.phone_survey.update_question_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
